import { AfterViewInit, Component, OnInit, ViewContainerRef } from '@angular/core';
import { AwallComponentEvent } from '../../../models/awallComponentEvent';
import { ComponentEvent } from '../../../models/enums/componentEvent';
import { WidgetWrapperComponent } from '../../widget-wrapper/widget-wrapper.component';
import { TOOLBAR_COMPONENT_ID } from '../const';
import { ToolbarStateTransitionHelper } from './ToolbarStateTransitionHelperClass';
import { ToolbarWidgetType } from '../ToolbarWidgetType';


@Component({
  selector: 'toolbar-widget-wrapper',
  templateUrl: './toolbar-widget-wrapper.component.html',
  styleUrls: [
  '../../widget-wrapper/widget-wrapper.component.scss',
  './toolbar-widget-wrapper.component.scss',
  ],
  })
export class ToolbarWidgetWrapperComponent extends WidgetWrapperComponent implements OnInit, AfterViewInit {
  protected widgetContainerId = 'toolbar-widget-dock-container';
  protected widgetDragContainerId = 'toolbar-widget-drag-container';
  protected widgetDragContainer: HTMLElement;
  protected docked = true;
  protected transitionHelper = ToolbarStateTransitionHelper;

  public widgetType: ToolbarWidgetType;
  public widgetWrapperInsertionPoint: ViewContainerRef;
  public widgetWrapperInsertionPointFloating: ViewContainerRef;

  ngOnInit(): void {
    super.ngOnInit();
    this.placeholderElement.style.display = 'none';
  }

  ngAfterViewInit() {
    this.widgetContainer = document.getElementById(this.widgetContainerId);
    this.widgetDragContainer = document.getElementById(this.widgetDragContainerId);
    this.wrapperElement = this.widgetWrapper.nativeElement;
    this.wrapperElement.setAttribute('data-widget-name', this.widgetName);

    super.setupInteraction();
  }

  protected handleDragStart(event: any): void {
    const index = this.widgetWrapperInsertionPoint.indexOf(this.wrapperComponentRef.hostView);

    if (index !== -1) {
      this.widgetWrapperInsertionPoint.detach(index);
      this.widgetWrapperInsertionPointFloating.insert(this.wrapperComponentRef.hostView);
    }

    super.handleDragStart(event);
  }

  protected handleDragEnd(event: any): void {
    const index = this.widgetWrapperInsertionPointFloating.indexOf(this.wrapperComponentRef.hostView);

    if (index !== -1) {
      this.widgetWrapperInsertionPointFloating.detach(index);
      this.widgetWrapperInsertionPoint.insert(this.wrapperComponentRef.hostView);
    }

    super.handleDragEnd(event);
  }

  /**
   * Toolbar dock button acts like the close button in the informationview.
   */
  public onDockButtonClicked() {
    super.onDockButtonClicked();
  }

  /**
   * Close-Button clicked in Wrapper-GUI. We send an event to the toolbar telling it to
   * close this wrapper.
   */
  public onCloseButtonClicked(): void {
    super.onDockButtonClicked();

    const data = { 'widgetName': this.widgetName, 'wrapperComponentRef': this.wrapperComponentRef };
    const closeEvent = new AwallComponentEvent(ComponentEvent.TOOLBAR_CLOSE_WRAPPER, data);
    this.communicationService.sendData(TOOLBAR_COMPONENT_ID, closeEvent);
  }

  public isInDock(): boolean {
    return this.widgetContainer.contains(this.wrapperElement)
      || this.widgetDragContainer.contains(this.wrapperElement);
  }
}
